export interface ApiErrorPayload {
  code?: string;
  message?: string;
  requestId?: string;
  details?: unknown;
}

export interface ApiErrorShape {
  error?: ApiErrorPayload;
}

export class ApiError extends Error {
  public readonly code: string;
  public readonly requestId?: string;
  public readonly details?: unknown;

  constructor(message: string, code: string, requestId?: string, details?: unknown) {
    super(message);
    this.name = "ApiError";
    this.code = code;
    this.requestId = requestId;
    this.details = details;
  }
}

export const parseApiError = (error: unknown): ApiError => {
  const fallback = new ApiError("Unexpected error", "UNKNOWN_ERROR");

  if (!error || typeof error !== "object") {
    return fallback;
  }

  const axiosLikeError = error as {
    message?: string;
    response?: { data?: ApiErrorShape };
  };
  const payload = axiosLikeError.response?.data?.error;

  if (!payload) {
    return new ApiError(axiosLikeError.message || fallback.message, fallback.code);
  }

  return new ApiError(
    payload.message || fallback.message,
    payload.code || fallback.code,
    payload.requestId,
    payload.details
  );
};
